module.exports = __webpack_public_path__ + "static/media/gg_profile.27dcb8c0.svg";